// localStorageUtils.js
const localStorageKey = "chartSettings";

export const initialValue = {
  standardDeviation: false,
  colorMode: "light",
  trendLine: false,
  textBox: false,
  xLabel: false,
  xLabelText: "",
  yLabel: false,
  yLabelText: "",
  title: false,
  titleText: "",
  bbm: "#000000",
  bbb: "964B00",
  bbt: "#964B00",
  bbfill: "#F5EEE6",
  symbol: "SPY",
  drawMode: false,
  stokeColor: "red",
  strokeWidth: 2,
  symbolName: "SPDR S&P 500 ETF Trust",
  startDate: new Date().toISOString().split('T')[0],
  candleStickPeriod: 'hour',
  eraserWidth: 5,
  textBoxFeat: {
    bgFill: "#D3D3D3",
    bgOpacity: 1,
    bgStrokeWidth: 1,
    fontSize: 12,
    fontWeight: "normal",
    text: "Enter Your Text...",
    textFill: "#F10040",
  },
  textList_1: [],
  chartType: 'candlestick',
  chartOverlay: 'off',
  chartIndicator: 'above',
  quote: false,
  period: 'hour',
  buyChartPeriod:'day',
  periodID: 6,
  enableBollinger: false,
  overlayBollingerPeriod: 'hour',
  overlaySmaPeriod: 'hour',
  indicatorParams: [],
  enableBB: false,
  enableSMA: false,
  enableSXMA: false,
  enableSSAR: false,
  overlayType: '',
  overlayParams: [],
  clearOverlay: 'false',
  clearIndicator: 'false',
  adxLength: '',
  cciLength: '',
  cmfLength: '',
  macdhValue: '',
  psarStandard: '',
  enableAdl: false,
  enableAdx: false,
  enableAl: false,
  enableCci: false,
  enableFi: false,
  enableMacd: false,
  enableMh: false,
  enableMfi: false,
  enableObv: false,
  enablePpo: false,
  enablePrice: false,
  enableRsi: false,
  enableRoc: false,
  enableFs: false,
  isMobile: false,
  lensig: '',
  drift: '',
  scalar: '',
  adlValue: '',
  adxValue: '',
  cciValue: '',
  cmfValue: '',
  macdValue: '',
  mfiValue: '',
  obvValue: '',
  ppoValue: '',
  pvoValue: '',
  rocValue: '',
  efiValue: '',
};

export const getInitialState = () => {
  const storedSettings = JSON.parse(localStorage.getItem(localStorageKey));
  return storedSettings || initialValue;
};

export const saveStateToLocalStorage = (state) => {
  localStorage.setItem(localStorageKey, JSON.stringify(state));
};
